import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import localeUtils from '../../../utils/localeUtils';
import { formatDate, parseDate } from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import { Form, Popup } from 'semantic-ui-react';
import FilterButton from '../../../components/Button/FilterButton';

import { CardContainer, Title, Header, Footer, Main } from '../styles';

const initialMalls = [{ key: '', value: '', text: 'Todos' }];

export default function Filter({ onClick, plateType, malls, errors }) {
  const [plate, setPlate] = useState('');
  const [type, setType] = useState('');
  const [mall, setMall] = useState('');
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());

  const modifiers = { start: fromDate, end: toDate };

  return (
    <CardContainer>
      <Header>
        <Title>Buscar Patentes</Title>
      </Header>
      <Main>
        <Form>
          <Form.Group>
            <Popup
              mouseEnterDelay={500}
              mouseLeaveDelay={200}
              content="Fecha de inicio para la búsqueda"
              trigger={
                <span style={{ margin: '0 9px' }}>
                  <Form.Field
                    error={errors.begin_datetimeError}
                    label="Fecha de Inicio *"
                    control={DayPickerInput}
                    value={fromDate}
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    formatDate={formatDate}
                    parseDate={parseDate}
                    onDayChange={day => setFromDate(day)}
                    dayPickerProps={{
                      localeUtils: localeUtils, locale: 'es' ,
                      selectedDays: [fromDate, { fromDate, toDate }],
                      modifiers,
                      disabledDays: {
                        after: new Date()
                        // after: toDate
                      },
                      numberOfMonths: 1
                    }}
                  />
                </span>
              }
            />
            <Popup
              mouseEnterDelay={500}
              mouseLeaveDelay={200}
              content="Fecha de fin para la búsqueda"
              trigger={
                <span style={{ margin: '0 9px' }}>
                  <Form.Field
                    error={errors.finish_datetimeError}
                    label="Fecha de Termino *"
                    control={DayPickerInput}
                    value={toDate}
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    formatDate={formatDate}
                    parseDate={parseDate}
                    onDayChange={day => setToDate(day)}
                    dayPickerProps={{
                      selectedDays: [fromDate, { fromDate, toDate }],
                      localeUtils: localeUtils, locale: 'es' ,
                      modifiers,
                      disabledDays: {
                        before: fromDate,
                        after: new Date()
                      },
                      numberOfMonths: 1
                    }}
                  />
                </span>
              }
            />
          </Form.Group>
          <Form.Group>
            <Popup
              mouseEnterDelay={500}
              mouseLeaveDelay={200}
              content="La patente a ingresar debe tener al menos 3 caracteres "
              trigger={
                <Form.Input
                  error={errors.plateError}
                  label="Patente *"
                  placeholder="Patente"
                  width={4}
                  value={plate}
                  onChange={(e, { value }) => setPlate(value)}
                  className="plateInput"
                />
              }
            />
            <Form.Select
              label="Tipo"
              placeholder="Todos"
              options={plateType}
              width={6}
              value={type}
              onChange={(e, { value }) => setType(value)}
            />
            <Form.Select
              label="Centro Comercial"
              placeholder="Todos"
              options={[...initialMalls, ...malls]}
              width={6}
              value={mall}
              onChange={(e, { value }) => setMall(value)}
            />
          </Form.Group>
        </Form>
      </Main>
      <Footer>
        <FilterButton
          className="btnFilter"
          onClick={() => onClick(plate, type, mall, fromDate, toDate)}
        />
      </Footer>
    </CardContainer>
  );
}

Filter.propTypes = {
  onClick: PropTypes.func,
  plateType: PropTypes.array,
  malls: PropTypes.array,
  errors: PropTypes.object
};
